import { PaginationMetadata, QuoteList, QuoteStatus, QuoteType } from "src/api-service";
import { DEFAULT_QUOTE_LIST_VISIBLE_COLUMNS } from "src/app/pages/home/page/quotes/components/quotes-table/quotes.columns";

// ============================================================================
// QUOTES LIST STATE
// ============================================================================
export interface QuotesState {
    // Data
    quotes: QuoteList[];
    loaded: boolean;
    loading: boolean;

    // Pagination & Sorting (from API response)
    pagination: PaginationMetadata | null;
    sortProperty: string;
    sortAscending: boolean;

    // Filters (user input)
    searchFilter: string;
    selectedStatuses: QuoteStatus[];
    selectedTypes: QuoteType[];
    customerCode: string | null;
    customerName: string | null;
    salesPersonCode: string | null;
    salesSupportPersonCode: string | null;
    locationCode: string | null;
    createdFrom: Date | null;
    createdTo: Date | null;
    validToFrom: Date | null;
    validToTo: Date | null;

    // UI-only (no reload needed)
    visibleColumns: string[];
}

export const initialQuotesState: QuotesState = {
    quotes: [],
    loaded: false,
    loading: false,
    pagination: null,
    sortProperty: "displayId",
    sortAscending: false,
    searchFilter: "",
    selectedStatuses: [QuoteStatus.Draft, QuoteStatus.Sent],
    selectedTypes: [],
    customerCode: null,
    customerName: null,
    salesPersonCode: null,
    salesSupportPersonCode: null,
    locationCode: null,
    createdFrom: null,
    createdTo: null,
    validToFrom: null,
    validToTo: null,
    visibleColumns: DEFAULT_QUOTE_LIST_VISIBLE_COLUMNS,
};